<template>
  <div class="edit-change-popup">
    <PopUp
      center-column
      bottom
      :clickOutsideClose="false"
      :title="`${$t('編輯敘述')}-${$t('原物料或化學材料之變更')}`"
      :pop-up-active="popupActive"
      @click=" popupCloseClick()"
    >
      <ValidationObserver
        ref="observeForm"
        class="edit-change-popup_content-wrap"
      >
        <LlState
          v-model="changeData.description"
          required
          type="textarea"
          :title="`${$t('敘述')}（${$t('變動因素描述')})`"
          rules="required"
          :placeholder="`${$t('若涉及此項變更，請詳細說明因素')}；${$t('若不涉及變更也請於此輸入“不涉及”')}`"
          :min-height="90"
        />
        <div class="edit-change-popup_content">
          <LlState
            v-model="changeData.expiredDate"
            required
            type="date"
            leading-icon="icon-datestart"
            rules="required"
            :title="$t('到期日')"
            @input="selectExpiredDate($event)"
          />
          <ChangeSystemContent
            v-for="(change,changeIndex) in changeData.systemChange"
            :key="changeIndex"
            :title="change.title"
            :icon="change.icon"
            :taker="change.taker"
            @taker-select="selectChangeTaker($event,changeIndex)"
          />
        </div>
      </ValidationObserver>
      <template slot="bottomBtn">
        <WsButton001
          out-line
          @click="popupCloseClick()"
        >
          {{ $t('取消') }}
        </WsButton001>
        <WsButton001 @click="submitClick()">
          {{ $t('儲存編輯') }}
        </WsButton001>
      </template>
    </PopUp>
  </div>
</template>
<script>
import { ValidationObserver } from "vee-validate";
export default {
  name: "EditChangePopup",
  components: {
    ValidationObserver,
  },
  props: {
    popupActive: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    changeData: {
      description: "原物料上漲因素，故將原料不鏽鋼404改為黃銅。",
      expiredDate: "",
      systemChange: [
        {
          icon: "icon-water",
          taker: null,
          title: "涉及水污染防治",
        },
        {
          icon: "icon-clean",
          taker: null,
          title: "涉及清潔生產",
        },
      ],
    },
  }),
  methods: {
    popupCloseClick() {
      this.$emit("click");
    },
    async submitClick() {
      const isValidate = await this.$refs.observeForm.validate();
      if (!isValidate) {
        return;
      }
      this.$emit("submit");
      this.$emit("click");
    },
    selectExpiredDate($event) {
      console.log($event);
    },
    selectChangeTaker($event, changeIndex) {
      let changeList = this.changeData.systemChange;
      changeList[changeIndex].taker = $event;
    },
  },
};
</script>
<style lang="scss">
@import "@/assets/scss/component/edit-change-popup";
</style>